import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as StorageRackActions from './storage-rack.actions';
import { StorageRackService } from 'app/modules/masters/storage-rack/storage-rack.service';
import { catchError, map, mergeMap, of } from 'rxjs';

@Injectable()
export class StorageRackEffects {
  constructor(
    private actions$: Actions,
    private service: StorageRackService
  ) {}

  // Load All Storage Racks
  loadStorageRacks$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StorageRackActions.loadStorageRacks),
      mergeMap(() =>
        this.service.getAll().pipe(
          map((storageRacks) =>
            StorageRackActions.loadStorageRacksSuccess({ storageRacks })
          ),
          catchError((error) =>
            of(StorageRackActions.loadStorageRacksFailure({ error }))
          )
        )
      )
    )
  );

  // Create a new Storage Rack
  createStorageRack$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StorageRackActions.createStorageRack),
      mergeMap(({ storageRack }) =>
        this.service.create(storageRack).pipe(
          map((created) =>
            StorageRackActions.createStorageRackSuccess({ storageRack: created })
          ),
          catchError((error) =>
            of(StorageRackActions.loadStorageRacksFailure({ error }))
          )
        )
      )
    )
  );

  // Update Storage Rack
  updateStorageRack$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StorageRackActions.updateStorageRack),
      mergeMap(({ id, storageRack }) =>
        this.service.update(id, storageRack).pipe(
          map((updated) =>
            StorageRackActions.updateStorageRackSuccess({ storageRack: updated })
          ),
          catchError((error) =>
            of(StorageRackActions.loadStorageRacksFailure({ error }))
          )
        )
      )
    )
  );

  // Delete Storage Rack
  deleteStorageRack$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StorageRackActions.deleteStorageRack),
      mergeMap(({ id }) =>
        this.service.delete(id).pipe(
          map(() => StorageRackActions.deleteStorageRackSuccess({ id })),
          catchError((error) =>
            of(StorageRackActions.loadStorageRacksFailure({ error }))
          )
        )
      )
    )
  );

  // 🔍 Search Storage Racks
searchStorageRacks$ = createEffect(() =>
  this.actions$.pipe(
    ofType(StorageRackActions.searchStorageRacks),
    mergeMap(({ query }) =>
      this.service.search(query).pipe(
        map((searchResults) =>
          StorageRackActions.searchStorageRacksSuccess({ searchResults })
        ),
        catchError((error) =>
          of(StorageRackActions.searchStorageRacksFailure({ error }))
        )
      )
    )
  )
);

}
